

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_khp24wwchl = () => {
                    
                        if (document.querySelector('.beae-vjmdi7jw:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-vjmdi7jw:not([data-beae-bind])'),
                                
                                id: 'beae-vjmdi7jw',
                                isLive: true
                            });
                            document.querySelector('.beae-vjmdi7jw:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-2c2kp1qi:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-2c2kp1qi:not([data-beae-bind])'),
                                
                                id: 'beae-2c2kp1qi',
                                isLive: true
                            });
                            document.querySelector('.beae-2c2kp1qi:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_khp24wwchl()
                } else {
                    window.beaePageJS.push(jsHandle_khp24wwchl)
                }
            